import { useSuspenseQuery } from '@tanstack/react-query';
import { Marker } from '@outdoria/types';
import { fetcher } from '../utils';
import { MARKER } from '../queryKeys';

export const useGetMarkerById = (marker_id?: string) => {
  const queryFn = async (): Promise<Marker> => {
    const res = await fetcher(`/v2/markers/${marker_id}`);
    return res.json();
  };

  const { data, isLoading, isFetched, isError } = useSuspenseQuery<
    Marker,
    unknown,
    Marker,
    string[]
  >({
    queryKey: [...MARKER, marker_id!],
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
